// JuzList.js
import React from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import icStart from './assets/images/item_star.png';


// Main component for displaying the list of Juz
const ChaptersList = ({
    chapters,
    setSelectedChapter,
    setSelectedAyatNumber,
    navMenuItemClick,
    setViewType
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const getChapterByNumber = (chapterNumber) =>
        chapters.find((chapter) => chapter.number == chapterNumber);

    const handleJuzClick = (chapter) => {


        setSelectedChapter(chapter);

        setSelectedAyatNumber(1);
        navMenuItemClick("read");
    };

    return (
        <Box mt={12} px={4} sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    maxWidth: '1000px',
                    justifyContent: isMobile ? 'center' : 'flex-start',
                }}
            >
                {chapters.map((chapter) => {

                    return (
                        <Box
                            key={chapter.number}
                            onClick={() => handleJuzClick(chapter)}
                            sx={{
                                flex: isMobile ? '1 1 100%' : '1 1 calc(50% - 1rem)',
                                p: 2,
                                borderRadius: '8px',
                                border: '1px solid #ddd',

                                cursor: 'pointer',
                            }}
                        >

                            <Grid container alignItems="center">
                                <Grid item xs={8}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box
                                            component="span"
                                            sx={{
                                                backgroundImage: `url(${icStart})`,
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                display: 'inline-block',
                                                width: 40,
                                                height: 40,
                                                textAlign: 'center',
                                                lineHeight: '40px',
                                                fontWeight: 'bold',
                                                borderRadius: '50%',
                                                marginRight: 1,
                                                flexShrink: 0,
                                            }}
                                        >
                                            <Typography variant="default_body" sx={{ fontWeight: 'bold' }}>     {chapter.number}</Typography>


                                        </Box>
                                        <Box>
                                            <Typography variant="default_body" sx={{ fontWeight: 'bold' }}>
                                                {chapter.title}
                                            </Typography>
                                            <br />
                                            <Typography variant="default_body" >
                                                {chapter.translation}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid
                                    item
                                    xs={4}
                                    sx={{
                                        direction: 'rtl',
                                        textAlign: 'right',
                                        unicodeBidi: 'isolate',
                                    }}
                                >
                                    <Typography variant="default_body">
                                        <strong> {chapter.arabicTitle}</strong>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default ChaptersList;
